
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/college-student-moving",
      function () {
        return require("private-next-pages/college-student-moving/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/college-student-moving"])
      });
    }
  